var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$route.name,attrs:{"id":"app"}},[_c('div',{staticClass:"px-5 py-5",attrs:{"id":"nav"}},[_c('h1',{staticClass:"mt-3"},[_c('router-link',{attrs:{"to":{ name: 'Home' }}},[_vm._v("Home")]),_vm._v(" | "+_vm._s(_vm.$route.name)+" ")],1)]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }